<multi-selector
  [nodes]="nodes$ | async"
  [nodesLoading]="nodesLoading"
  [triggerOpen]="true"
  [searchFunctionPlaceholder]="searchFn"
  (openChange)="onOpenChange($event)"
  (expandChange)="onExpandChange($event)"
  (valueUpdate)="onUpdatedValue($event)"></multi-selector>
